<div class="radialProgressBar progress-10">
  <div class="overlay">10</div>
</div>
